<template>
  <div class="drawer-box">
    <el-drawer
    class="drawer-cont"
    v-model="visible"
    center
    size="50%"
    @close="close">
    <!-- <template #header>
      <div class="dialog-header">GrowKYC提交</div>
    </template> -->
    <template #header>
      <div class="dialog-header">
        <span>{{t('dict.label.title')}}</span>
      </div>
    </template>
    <el-form
      v-if="isFormReady"
      :model="form"
      :rules="rules"
      ref="formRef"
      label-position="left"
      label-width="190px"
      :validate-on-rule-change="false"
      >
      <el-form-item :label="t('dict.label.scoreAuditResult')" prop="scoreAuditResult">
        <GrowGycAuditResult :score-list="kycScoreViewList"/>
      </el-form-item>
      <el-form-item :label="t('dict.label.acctId')">
        <span>{{ form.acctId }}</span>
      </el-form-item>
      <el-form-item :label="t('dict.label.acctName')">
        <span>{{ form.acctName }}</span>
      </el-form-item>
      <el-form-item :label="t('dict.label.annualSales')" prop="annualSales">
        <el-select v-model="form.annualSales" :placeholder="t('dict.validate.annualSales')">
          <el-option v-for="{ label, value} in annualSalesOptions" :key="value" :label="label" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="t('dict.label.companyScale')" prop="companyScale">
        <el-select v-model="form.companyScale" :placeholder="t('dict.validate.companyScale')">
          <el-option v-for="{ label, value} in companyScaleOptions" :key="value" :label="label" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="t('dict.label.transMode')" prop="transMode" >
        <el-select v-model="form.transMode" :placeholder="t('dict.validate.transMode')" @change="handleCompanyScaleChange">
          <el-option v-for="{ label, value} in transModeOptions" :key="value" :label="label" :value="value" />
        </el-select>
      </el-form-item>
      <!-- todo -->
      <el-form-item :label="t('dict.label.tradeType')" prop="tradeType">
        <el-select v-model="form.tradeType" multiple :placeholder="t('dict.validate.tradeType')" @change="showError = true">
          <el-option v-for="(value, key) in cascade.transMode[form.transMode]" :key="key" :label="value" :value="parseInt(key)" />
        </el-select>
      </el-form-item>
      <el-form-item :label="t('dict.label.commodityDesc')" prop="commodityDesc">
        <el-input style="width:272px" v-model="form.commodityDesc"   type='textarea' :placeholder="t('dict.validate.commodityDesc')" maxlength="1024" />
      </el-form-item>
      <el-form-item :label="t('dict.label.tradeOpponent')" prop="tradeOpponent">
        <el-select v-model="form.tradeOpponent" multiple :placeholder="t('dict.validate.tradeOpponent')" @change="showError = true">
          <el-option v-for="{ label, value} in tradeOpponentOptions" :key="value" :label="label" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="t('dict.label.transCur')" prop="transCur">
        <el-select v-model="form.transCur" multiple :placeholder="t('dict.validate.transCur')" @change="showError = true">
          <el-option v-for="{ label, value} in transCurOptions" :key="value" :label="label" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="t('dict.label.eptMonthAmt')" prop="eptMonthAmt">
        <el-select v-model="form.eptMonthAmt" :placeholder="t('dict.validate.eptMonthAmt')">
          <el-option v-for="{ label, value} in eptMonthAmtOptions" :key="value" :label="label" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item :label="t('dict.label.otherInformation')"  prop="otherInformation">
        <el-input style="width:272px" v-model="form.otherInformation"   type='textarea' :placeholder="t('dict.validate.otherInformation')" maxlength="65535" />
      </el-form-item>
      <el-form-item :label="t('dict.label.image')" prop="fileIdList">
          <sr-upload-plus v-for="(item,key) in form.fileForIds"
            :key="key"
            :growUrl="true"
            fileTag="otherFile"
            v-model:fileIdList="item.fileId"
            @uploading='handleFileUploading'
            @change="handleFileChange"
            :initialFileList="item.initialFileList"
            @remove="removefileIdList"
            :filePrefix="FILE.PREFIX.OTHER_MATERIAL"
            :acct-id="form.acctId"  />
      </el-form-item>
      <el-form-item :label="t('dict.label.selfCheckFileInfoList')">
        <sr-upload-plus v-for="(item,key) in form.checkForIds"
          :key="key"
          :growUrl="true"
          fileTag="otherFile"
          v-model:fileIdList="item.fileId"
          @uploading='handleFileUploading'
          :initialFileList="item.initialFileList"
          :filePrefix="FILE.PREFIX.OTHER_MATERIAL"
          @remove="removeCheckfileIdList"
          :acct-id="form.acctId"  />
      </el-form-item>
      <el-form-item>
        <el-button @click="close">{{t('commonBtn.btn.cancel')}}</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmitClick"
          >{{t('commonBtn.btn.submit')}}</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</div>
</template>

<script setup>
import { reactive, ref, defineExpose, defineEmits, nextTick } from 'vue'
import { useI18n } from '@/plugins/i18n'
import SrUploadPlus from '@/components/sr-upload-plus'
import { commonUtils, vab } from '@libs/utils'
import { getAcctBusiness, saveAcctBusiness } from "@/api/modules/list"
import { useStore } from 'vuex'
import {
  annualSalesOptions,
  companyScaleOptions,
  transModeOptions,
  tradeOpponentOptions,
  transCurOptions,
  eptMonthAmtOptions,
  cascade
} from "@/domain/modules/client-options"
import GrowGycAuditResult from './grow-kyc-audit-result'
const { t } = useI18n()
const emits = defineEmits(['refresh'])
const store = useStore()
const { FILE } = store.state.base.constant
const visible = ref(false)
const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const formRef = ref(null)
const loading = ref(false)
const isFormReady = ref(false)
const showError = ref(false)
const kycScoreViewList = ref([])
const form = reactive({
  acctId: '',
  acctName: '',
  annualSales: '',
  companyScale: '',
  transMode: '',
  tradeType: '',
  commodityDesc: '',
  tradeOpponent: '',
  transCur: '',
  eptMonthAmt: '',
  otherInformation: '',
  fileIdList: [],
  fileForIds: [
    { fileId: [], filename: '', initialFileList: [] }
  ],
  checkForIds: [
    { fileId: [], filename: '', initialFileList: [] }
  ],
  selfCheckFileIdList: []
})
const fileUpload = reactive({
  fileId: '',
  selfCheckFileId: ""
})
const createMultiSelectRule = (message) => {
  return [
    {
      required: true,
      validator: (rule, value, callback) => {
        console.log(showError.value, 'showError.value')
        if (!showError.value) return callback()
        if (!value || value.length === 0) {
          callback(new Error(message))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ]
}
const rules = {
  annualSales: [
    { required: true, message: t('dict.validate.annualSales') }
  ],
  companyScale: [
    { required: true, message: t('dict.validate.companyScale') }
  ],
  transMode: [
    { required: true, message: t('dict.validate.transMode') }
  ],
  tradeType: createMultiSelectRule(t('dict.validate.tradeType')),
  commodityDesc: [
    { required: true, message: t('dict.validate.commodityDesc'), trigger: 'blur' }
  ],
  tradeOpponent: createMultiSelectRule(t('dict.validate.tradeOpponent')),
  transCur: createMultiSelectRule(t('dict.validate.transCur')),
  eptMonthAmt: [
    { required: true, message: t('dict.validate.eptMonthAmt') }
  ],
  fileIdList: [
    {
      required: true,
      validator: (rule, value, callback) => {
        // 检查是否有至少一个有效文件
        const { fileId } = form.fileForIds[0]
        if (!fileId || fileId.length === 0) {
          callback(new Error(t('dict.validate.image')))
          return
        }
        callback()
      },
      trigger: 'change'
    }
  ]
}

const open = (row) => {
  visible.value = true
  // 名称和id从列表获取
  const { acctId, acctName } = row
  form.acctId = acctId
  form.acctName = acctName
  getDetail(row)
}
const getDetail = async (row) => {
  try {
    const params = {
      acctId: row.acctId,
      userId: store.state.user.userId,
    }
    const res = await getAcctBusiness(params)
    // const res = {
    //     "businessId": "1925435115986939905",
    //     "acctId": "78357293",
    //     "acctName": "hdsfkjhsdkjf",
    //     "annualSales": "A",
    //     "companyScale": "1",
    //     "transMode": "1",
    //     "tradeType": "3,4,2",
    //     "tradeOpponent": null,
    //     "transCur": "USD",
    //     "creatorId": "aw162556",
    //     "creatorName": "刘影",
    //     "eptMonthAmt": "1",
    //     "commodityDesc": "test desc",
    //     "innerRole": "0",
    //     "otherInformation": "333",
    //     "fileIdList": ["FIL1927552782936907778", "FIL1927553145756786690", "FIL1927563569952792578"],
    //     "selfCheckFileIdList": ["FIL1927552782936907778", "FIL1927563569952792578"],
    //     "createTime": "2025-05-22T14:14:39",
    //     "updateTime": "2025-05-22T14:14:39",
    //     "kycScoreViewList": [
    //         {
    //             "acctId": "78357293",
    //             "onsite": null,
    //             "kycScore": null
    //         }
    //     ]
    // }
    kycScoreViewList.value = res.kycScoreViewList || []
    // kycScoreViewList.value =  [{acctId: "96517312", onsite: 0, kycScore: null}]
    const data = {
      ...res,
      tradeType: res.tradeType ? res.tradeType.split(',').map(Number) : "",
      tradeOpponent: res.tradeOpponent ? res.tradeOpponent.split(',') : "",
      transCur: res.transCur ? res.transCur.split(',') : "",
      acctId: form.acctId,
      acctName: form.acctName
    }
    Object.assign(form, data)
    if (res && form.fileForIds.length) {
      form.fileForIds = form.fileForIds.map(item => ({ ...item, fileId: res.fileIdList, initialFileList: res.fileIdList }))
    }
    if (res && form.checkForIds.length) {
      form.checkForIds = form.checkForIds.map(item => ({ ...item, fileId: res.selfCheckFileIdList, initialFileList: res.selfCheckFileIdList }))
    }
    nextTick(() => {
      isFormReady.value = true
    })
  } catch (e) {
    console.log(e)
  }
}
const handleCompanyScaleChange = () => {
  form.tradeType = ''
  showError.value = true
};
const handleFileUploading = ({ status }) => {
  loading.value = status === 'uploading'
  formRef.value.validateField('fileIdList')
}
const handleFileChange = () => {
  formRef.value.validateField('fileIdList')
}

const removeCheckfileIdList = async (file) => {
  // console.log(file, 'file ===')
}
const removefileIdList = async (file) => {
  formRef.value.validateField('fileIdList')
}
const close = () => {
  visible.value = false
  isFormReady.value = false
  showError.value = false
  nextTick(() => {
    if (formRef.value) {
      formRef.value.resetFields()
    }
  })
}
const handleSaveFileIds = (list) => {
  const fileIdsParams = list.reduce((pre, cur) => {
    if (cur.fileId && cur.fileId.length) {
      pre.push(...cur.fileId)
    }
    return pre
  }, [])
  return fileIdsParams
}
const handleSubmitClick = commonUtils.throttle(() => {
  showError.value = true
  formRef.value.validate(async valid => {
    if (!valid) return
    try {
      loading.value = true
      const { fileForIds, checkForIds, transCur, tradeType, tradeOpponent } = form
      const params = {
        ...form,
        userId: store.state.user.userId,
        fileIdList: handleSaveFileIds(fileForIds),
        selfCheckFileIdList: handleSaveFileIds(checkForIds),
        tradeType: tradeType.join(),
        tradeOpponent: tradeOpponent.join(),
        transCur: transCur.join()
      }
      delete params.fileForIds
      delete params.checkForIds
      await saveAcctBusiness(params)
      vab.baseMessage('操作成功')
      close()
      emits('fetchData')
    } finally {
      loading.value = false
    }
  })
})

defineExpose({
  open
})
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.drawer-box{
  :deep(.drawer-cont) {
    .el-drawer__header{
      padding:20px;
      background-color: #F5FCFE;
      margin-bottom: 0;
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    .el-select .el-input{
      width:500px;
    }
    .el-textarea__inner{
      width:500px;
    }
  }
  :deep(.el-form-item label) {
    font-weight: 400;
  }
}
</style>